import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { Locale } from "@/Common/Models/Localization/Locale";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";

class FlatLookupViewResponse {
    public LookupID: string;
    public PrimaryKeyID: string;
    public LookupTypeName: string;
    public LookupTypeCode: string;
    public LookupCode: string;
    public LookupTypeID: string;
    public LookupPosition: number;
    public en: string;
    public fr: string;
    public esMX: string;
    public enValueID: string;
    public frValueID: string;
    public enLocalizedValueID: string;
    public frLocalizedValueID: string;
}

class FlatLookupView extends FlatLookupViewResponse {
    constructor(fl: FlatLookupViewResponse = null) {
        super();

        if (fl != null) {
            this.LookupID = fl.LookupID;
            this.PrimaryKeyID = fl.PrimaryKeyID;
            this.LookupTypeName = fl.LookupTypeName;
            this.LookupTypeCode = fl.LookupTypeCode;
            this.LookupCode = fl.LookupCode;
            this.LookupTypeID = fl.LookupTypeID;
            this.LookupPosition = fl.LookupPosition;
            this.en = fl.en;
            this.fr = fl.fr;
            this.esMX = fl.esMX;
            this.enValueID = fl.enValueID;
            this.frValueID = fl.frValueID;
            this.enLocalizedValueID = fl.enLocalizedValueID;
            this.frLocalizedValueID = fl.frLocalizedValueID;
        }
    }

    public GetValue(locale: Locale = null): string {
        locale = locale ?? sessionStore.locale;

        let value = this.en;
        if (locale == Locale.fr)
            value = this.fr;
        else if (locale == Locale.es)
            value = this.esMX;

        return value || this.en || "";
    }

    public ToComboboxItem(): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(this.LookupID, this.GetValue(), this.LookupPosition);
    }

    public ToSearchableItemModel(locale: Locale = null): SearchableItemModelT<FlatLookupView> {
        return new SearchableItemModelT<FlatLookupView>(this.GetValue(locale), this.LookupID, this);
    }
}

export { FlatLookupView, FlatLookupViewResponse };
